export const POLYGON_COMPLETE_EVENT = "polygoncomplete";
export const POLYGON_EDITED_EVENT = "set_at";
export const MARKER_COMPLETE_EVENT = "markercomplete";
export const CLICK_EVENT = "click";
export const MOUSE_OVER_EVENT = "mouseover";
export const MOUSE_OUT_EVENT = "mouseout";

export const MAP_INITIAL_LATITUDE = 43.759459;
export const MAP_INITIAL_LONGITUDE = 11.207739;

export const PRODUCT_MARKER_PITCH_OFFSET = 10;

export const MAP_STYLE = {
    featureType: "poi",
    elementType: "labels",
    stylers: [
        { visibility: "off" }
    ]
};

export const POLYGON_OPTIONS = {
    draggable: false,
    editable: false,
    fillColor: "#F2F2F2",
    strokeColor: "#F2F2F2",
    fillOpacity: 0.5,
    strokeWeight: 3,
    path: null
};
